/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const commandEntity = {

    entity: "command",
    label: "Command",

    fields: [

        {
            key: "command_id",
            label: "ID",
            type: "uuid",
            visible: false,
            editable: false
        },

        {
            key: "command_key",
            label: "Key",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "command_name",
            label: "Name",
            type: "text",
            visible: true,
            editable: true
        },

        {
            key: "command_type",
            label: "Type",
            type: "select",
            options: ["system", "domain", "integration"],
            visible: true,
            editable: true
        },

        {
            key: "payload",
            label: "Payload",
            type: "json",
            visible: true,
            editable: true
        },

        {
            key: "command_status",
            label: "Status",
            type: "select",
            options: ["pending", "executed", "failed"],
            visible: true,
            editable: true
        },

        {
            key: "created_at",
            label: "Created",
            type: "datetime",
            visible: false,
            editable: false
        },

        {
            key: "executed_at",
            label: "Executed",
            type: "datetime",
            visible: false,
            editable: false
        }

    ]

}